import clsx from 'clsx';
import type { ReactNode } from 'react';

interface DashboardCardProps {
	title: string;
	subtitle?: string;
	action?: ReactNode;
	className?: string;
	children: ReactNode;
	tourId?: string;
}

export function DashboardCard({ title, subtitle, action, className, children, tourId }: DashboardCardProps) {
	return (
		<section className={clsx('flex flex-col rounded-2xl border border-raro-gray-200 bg-white p-4 md:p-5 shadow-sm', className)} data-tour={tourId}>
			<header className="mb-4 flex flex-wrap items-start justify-between gap-3">
				<div className="min-w-0">
					<h3 className="text-sm font-semibold text-raro-gray-900 font-montserrat">{title}</h3>
					{subtitle && <p className="mt-0.5 text-xs text-raro-gray-500">{subtitle}</p>}
				</div>
				{action && <div className="flex-shrink-0">{action}</div>}
			</header>
			<div className="min-h-0 flex-1">{children}</div>
		</section>
	);
}

interface EmptyChartProps {
	message: string;
	height?: number;
}

export function EmptyChart({ message, height = 220 }: EmptyChartProps) {
	return (
		<div className="flex items-center justify-center text-center" style={{ height }}>
			<p className="max-w-[16rem] text-sm text-raro-gray-400">{message}</p>
		</div>
	);
}
